import { Controller } from "stimulus";

export default class extends Controller {
    static targets = [
       'dateofbirth', 'agelabel'
    ]

    fill() {
        if (this.dateofbirthTarget.value.length != 10) {
            this.agelabelTarget.style.display = 'none'
            return;
        }

        this.agelabelTarget.style.display = 'block'
        const [day, month, year] = this.dateofbirthTarget.value.split("/")
        const age = getAge(new Date(year, month - 1, day))
        this.agelabelTarget.innerHTML = "Paciente com <strong>{{year}} {{label}}</strong>"
            .replace("{{year}}", age)
            .replace("{{label}}", age > 1 ? "anos" : "ano")
    }
}

function getAge(date) {
    var diff = Date.now() - date.getTime();
    var age = new Date(diff);
    return Math.abs(age.getUTCFullYear() - 1970);
}
